import { Component, Input, OnInit, inject } from "@angular/core";
import { MappingPatternStore } from "@app/services/store/mapping-pattern-store";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { PatternEntrySchedulerComponent } from "../pattern-entry-scheduler/pattern-entry-scheduler.component";

@Component({
  selector: "app-mapping-pattern-detail-component",
  templateUrl: "./mapping-pattern-detail.component.html",
  styleUrls: ["./mapping-pattern-detail.component.scss"],
  imports: [PatternEntrySchedulerComponent]
})
export class MappingPatternDetailComponent implements OnInit {
  private mappingPatternStore = inject(MappingPatternStore);
  private serviceErrorHandler = inject(ServiceErrorHandlerService);

  @Input() pattern: string;
  patternObj: ResourceFactMappingPattern;
  loading = true;

  ngOnInit() {
    this.loadPattern();
  }

  loadPattern() {
    this.loading = true;
    this.mappingPatternStore
      .loadSingle(parseInt(this.pattern, 10), true)
      .then((pattern) => {
        this.patternObj = pattern;
        this.loading = false;
      })
      .catch((error) => {
        this.serviceErrorHandler.handleError(error);
        this.loading = false;
      });
  }
}
